import { render, staticRenderFns } from "./modelOne.vue?vue&type=template&id=06095f8e&scoped=true&"
import script from "./modelOne.vue?vue&type=script&lang=js&"
export * from "./modelOne.vue?vue&type=script&lang=js&"
import style0 from "./modelOne.vue?vue&type=style&index=0&id=06095f8e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06095f8e",
  null
  
)

export default component.exports